import React from 'react';
import { FormattedMessage } from 'react-intl';

import classNames from 'classnames';
import { Message, SenderStatus } from '../../types';
import MessageSubTypes from '../../models/enums/MessageSubTypes';

import styles from './MessageDetails.module.css';

export function MessageDetails({ message }: { message: Message }) {
  const { createdAt, senderStatus, isOutgoing, subType } = message;
  const isSmsAutomatedOptMessage =
    subType === MessageSubTypes.SMS_OPT_OUT_NOTIFICATION ||
    subType === MessageSubTypes.SMS_OPT_IN_NOTIFICATION;
  const hideDeliveryStatus = isSmsAutomatedOptMessage;

  let status: string = senderStatus;
  let statusColor = 'normalStatus';
  if (senderStatus === SenderStatus.Sent) {
    status = 'DELIVERED';
  } else if (senderStatus === SenderStatus.Failed) {
    statusColor = 'errorStatus';
  }

  return (
    <div className={styles.messageDetails}>
      <span className={styles.timestamp} aria-label="message-timestamp">
        {createdAt.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' })}
      </span>
      {!hideDeliveryStatus && isOutgoing && senderStatus !== SenderStatus.Retrying && (
        <span
          className={classNames(styles.status, styles[statusColor])}
          aria-label="message-status"
        >
          <FormattedMessage id={`messageStatus.${status}`} />
        </span>
      )}
    </div>
  );
}

export default MessageDetails;
